import { Component } from '@angular/core';

@Component({
    selector: 'gbc-empty',
    template: ''
})
export class EmptyComponent {}
